import { render, staticRenderFns } from "./SendImageMap.vue?vue&type=template&id=cac8bdec&scoped=true&"
import script from "./SendImageMap.vue?vue&type=script&lang=js&"
export * from "./SendImageMap.vue?vue&type=script&lang=js&"
import style0 from "./SendImageMap.vue?vue&type=style&index=0&id=cac8bdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac8bdec",
  null
  
)

export default component.exports